<div class="card">
  <div class="card-title">{{ title }}</div>
  <div class="card-value">{{ value }}</div>
  <div class="card-sub">{{ sub }}</div>
</div>
